import { loadCadenas } from "@/lib/cadenas/loader";

export async function reverseLookup(catalog: string, artikelnummer: string) {
	let cadenas = await loadCadenas();

	return await cadenas.Services.Search.reverseLookup({
		catalog,
		part: artikelnummer,
		exact: 0,
	});
}
